import { Environment } from '@galaxy/core';
import { productIds } from '../../globals';

export class GetStartedConstantsHelper {
  private readonly environment: Environment;

  private readonly exclusionLists = {
    PROD: [
      'f617df45-4b71-4bad-ae4b-645ef0bcead0', // facebook
      '85d1553e-172a-40f8-a976-61406a3cab70', // GA
      '071a38e8-4ac6-4c94-8477-d10579efcebe', // GBP
      'b295b6ae-bc27-40fe-b88b-90ce90ed090f', // Google Meet
      '1976b1be-4194-4fbd-9c51-ab7e241dc6cc', // GSC
      'e0cc9e85-6ee0-4fb5-b7b9-f9a2053065dd', // Instagram
      '0035c813-221f-4ad7-b444-6aea5916fbe6', // Quickbooks Online
      '7b5fe144-363f-4f1b-93f5-176bd6fe522e', // Quickbooks Online: personal
      '1fe93bc4-994f-4928-aa18-619afdbfacbc', // Zoom
    ],
    DEMO: [
      '5e617f15-6b02-4a34-a0c5-8983fda4b131', // facebook
      '72d32188-de0d-4aeb-b397-5f9555d00342', // GA
      '2c64bdd7-cde6-4aad-a3d4-620eececcc17', // GBP
      '98f4e8da-1b55-4f20-bc3e-1eedfb62685f', // Google Meet
      '0960b3aa-a857-46aa-87bf-aa26c3a56404', // GSC
      'e89f5083-d700-4e6c-af8e-05c57d82a671', // Instagram
      '822c4951-c67d-4452-b28a-63a99ccec1e0', // Quickbooks Online
      '7eb3f16c-17e7-4749-bc11-a3ecda6344e7', // Quickbooks Online: personal
      '8817d1ff-9913-4b56-81d8-fc3ec6e244dc', // Zoom
    ],
  };

  private readonly gbpIntegrationIds = {
    PROD: '071a38e8-4ac6-4c94-8477-d10579efcebe', // PROD GBP Integration ID
    DEMO: '2c64bdd7-cde6-4aad-a3d4-620eececcc17', // DEMO GBP Integration ID
  };

  constructor(environment: Environment) {
    this.environment = environment;
  }

  getExclusionList(): string[] {
    if (this.environment === Environment.PROD) {
      return this.exclusionLists.PROD;
    }
    return this.exclusionLists.DEMO;
  }

  getGbpIntegrationId(): string {
    if (this.environment === Environment.PROD) {
      return this.gbpIntegrationIds.PROD;
    }
    return this.gbpIntegrationIds.DEMO;
  }
}

export const SMSProducts = [productIds.reputationManagement, productIds.inboxPro, productIds.campaignsPro];

export const aiWebChatProducts = [productIds.inboxPro, productIds.aiWebchat];

export const a2PStartDate = new Date(2023, 1, 1); // when Vendasta starts development on A2P

export const getStartedStepIds = {
  signUp: 'sign_up',
  gbpConnection: 'gbp_connection',
  integrationConnection: 'integration_connection',
  webchatSetup: 'webchat_setup',
  smsRegistration: 'sms_registration',
  mobileNotification: 'mobile_notification',
};

export function getSkipIds(stepID: string): string {
  switch (stepID) {
    case getStartedStepIds.gbpConnection:
    case getStartedStepIds.integrationConnection:
    case getStartedStepIds.webchatSetup:
    case getStartedStepIds.smsRegistration:
    case getStartedStepIds.mobileNotification:
      return 'skipped_' + stepID;
    default:
      return stepID;
  }
}
